import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IReportDetailsResponse } from 'app/models/report-details.models';
import { environment } from 'environments/environment';
import { Observable, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportDetailsService {
  constructor(private http: HttpClient) {}

  getReportDetails(id: string, days: number): Observable<IReportDetailsResponse | null> {
    return this.http
      .get<IReportDetailsResponse>(`${environment.apiUrl}/api/analytics/operations/${id}`, {
        params: new HttpParams().append('days', days),
      })
      .pipe(
        catchError(() => {
          return of(null);
        }),
      );
  }
}
